import { progressAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(progressAnatomy.keys);

const baseStyle = definePartsStyle(() => {
  return {
    filledTrack: {
      // bg: "whiteAlpha.800",
    },
    track: {
      borderRadius: "10rem",
      // border: "1px solid",
      // borderColor: "whiteAlpha.300",
    },
  };
  // return {};
});

const progressTheme = defineMultiStyleConfig({
  baseStyle,
});

export default progressTheme;
